export const CRITICALITIES = {
  low: { label: 'Baixa', badge: 'badge-info' },
  medium: { label: 'Média', badge: 'badge-warning' },
  high: { label: 'Alta', badge: 'badge-danger' },
}

export function criticalityLabel(value) {
  return CRITICALITIES[value] ? CRITICALITIES[value].label : (value || '—')
}

export function criticalityBadge(value) {
  return CRITICALITIES[value] ? CRITICALITIES[value].badge : 'badge-secondary'
}

export function fieldsByKey(catalog) {
  return (catalog.fields || []).reduce((map, field) => ({ ...map, [field.key]: field }), {})
}

export function describeCondition(condition, fields) {
  const field = fields[condition.field] || { label: condition.field, type: 'number' }

  if (field.type === 'boolean') {
    const on = condition.value === true || condition.value === 'true' || condition.value === 1
    const positive = condition.operator === '=' ? on : !on

    const state = positive ? (field.on || 'Ligado') : (field.off || 'Desligado')

    return `${field.label} ${state.toLowerCase()}`
  }

  return `${field.label} ${condition.operator} ${condition.value}${field.unit ? ` ${field.unit}` : ''}`
}
